import vIcon from '@/components/form/v-icon';
import SortingOrders from '@/components/grid/sorting-orders';

/**
 * Render the default header style for the grid column.
 * @param {CachedColumn} cachedColumn
 * @param {Function} createElement
 * @param {Vue} eventBus Internal grid event bus used for event dispatching
 * @param {Object|null} sortBy Object literal containing the column field as the key and the
 * type of sort as the value, e.g. {createdTime: 'asc'}
 * @returns {Array}
 */
export default function defaultHeader({
    cachedColumn, createElement, grid,
}) {
    const {eventBus, sortBy = null} = grid;
    // if column is type numeric align text to right
    const classes = {
        'text-right': cachedColumn.type === 'numeric',
        'is-resizeable': cachedColumn.resizeable,
    };

    if (cachedColumn.sortable) {
        const children = [cachedColumn.header];
        const isSortingOnColumn = sortBy ? !!sortBy[cachedColumn.field] : false;
        let title = 'Click to sort descending';
        classes['is-sortable'] = true;

        if (isSortingOnColumn) {
            // we determine the current sorting value on the column
            // to modify the caret icon rendered next to the column's header
            const isOrderAsc = sortBy[cachedColumn.field] === SortingOrders.ascending;
            children.push(createElement(
                vIcon,
                {
                    props: {
                        icon: isOrderAsc ? 'caret-up' : 'caret-down',
                    },
                },
            ));
            title = !isOrderAsc ? 'Click to sort ascending' : 'Click to remove sort';
        }
        return [
            'th',
            {
                class: classes,
                attrs: {
                    title,
                },
                on: {
                    // listen for clicks on the header to toggle
                    // through the different sorting states
                    mousedown: () => {
                        eventBus.$emit('sort-change', {
                            field: cachedColumn.field,
                        });
                    },
                },
            },
            children,
        ];
    }
    return [
        'th',
        {
            class: classes,
        },
        cachedColumn.header,
    ];
}
